<template>
  <div
    class="other-school-support__banner"
    @click="openModal(MODAL_TYPES.checkList)"
  >
    <h3><span>чек-лист</span> по&nbsp;переходу на&nbsp;семейное образование</h3>

    <button
      class="m-btn"
      @click.stop="openModal(MODAL_TYPES.checkList)"
    >
      скачать чек-лист
    </button>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { MODAL_TYPES } from '../common/AppHeader/data';

export default {
  name: 'SchoolNewCheckList',
  data: () => ({
    MODAL_TYPES,
  }),
  methods: {
    ...mapActions('appHeaderModals', {
      openModal: 'openModal',
    }),
  },
};
</script>

<style scoped lang="scss">

.other-school-support__banner {
  height: calc(var(--scale) * 350);
  margin-top: calc(var(--scale) * 20);
  padding: calc(var(--scale) * 24) calc(var(--scale) * 40) calc(var(--scale) * 40);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  background-image: url("/v2/school-new/other-pages/support/banner.webp");
  background-size: cover;
  border-radius: calc(var(--scale) * 60);
  cursor: pointer;

  @include media-down($size-tablet) {
    height: calc(var(--scale) * 140);
    margin-top: calc(var(--scale) * 8);
    padding: calc(var(--scale) * 9) calc(var(--scale) * 16) calc(var(--scale) * 16);
    border-radius: calc(var(--scale) * 24);
  }

  @include media-down($size-mobile) {
    height: calc(var(--scale) * 366);
    padding: calc(var(--scale) * 12) calc(var(--scale) * 16) calc(var(--scale) * 16);
    border-radius: calc(var(--scale) * 32);
    background-image: url("/v2/school-new/other-pages/support/banner-mob.webp");
  }

  h3 {
    max-width: calc(var(--scale) * 1207);

    font-weight: 500;
    font-size: calc(var(--scale) * 80);
    line-height: 90%;
    letter-spacing: -0.04em;
    color: #4F0338;

    span {
      color: #D524A9;
    }

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 450);
      font-size: calc(var(--scale) * 32);
    }

    @include media-down($size-mobile) {
      font-size: calc(var(--scale) * 36);
    }
  }

  .m-btn {
    margin-top: auto;
    padding: calc(var(--scale) * 34) calc(var(--scale) * 56);
    background-color: #76195A;
    border-radius: calc(var(--scale) * 24);

    font-weight: 500;
    font-size: calc(var(--scale) * 32);
    line-height: 110%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 14) calc(var(--scale) * 22);
      border-radius: calc(var(--scale) * 16);
      font-size: calc(var(--scale) * 18);
      letter-spacing: -0.02em;
    }
  }
}

</style>
